module.exports = __webpack_public_path__ + "img/qg1_01.00efebba.png";